<template>
  <div class="points-w p-20px">
    <el-row>
      <el-col :span="24">
        <el-input
          size="small"
          placeholder="测点编码或测点名称"
          v-model="keyword"
          class="input_width mr-5px"
          clearable
          @keypress.enter.native="sizeChange"
        ></el-input>
        <!-- <el-select filterable size="small" v-model="label" clearable placeholder="测点标签" popper-class="visualization-select-popper">
          <el-option
            v-for="item in pointLabels"
            :value="item.displayName"
            :label="item.displayName"
            :key="item.id"
          ></el-option>
        </el-select> -->
        <el-tooltip placement="top" :open-delay="1000" content="搜索">
          <el-button size="small" class="ml-10px" type="primary" @click="sizeChange"
            >搜索</el-button
          >
        </el-tooltip>
      </el-col>
    </el-row>
    <el-table
      ref="table"
      :data="pointList"
      :row-key="(row) => row.id"
      :highlight-current-row="true"
      class="mt-10px"
      height="500px"
      v-loading="tableLoading"
      @select="selectChange"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-table-column
        align="center"
        width="55"
        type="selection"
        :selectable="isDisabledToSelect"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column show-overflow-tooltip prop="code" label="测点编码"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="测点名称"></el-table-column>
      <!-- <el-table-column show-overflow-tooltip prop="labels" label="测点标签"></el-table-column> -->
      <el-table-column show-overflow-tooltip prop="unit" label="单位"></el-table-column>
    </el-table>
    <div class="w-full text-right">
      <el-pagination
        class="r mt-10px"
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="page.pageNo"
        :page-sizes="pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        background
        :pager-count="5"
      >
      </el-pagination>
    </div>
    <div class="bottom_button w-full pt-10px">
      <el-button
        type="primary"
        class="iconfont icon-save"
        size="small"
        @click="saveBtnClick"
        :loading="saveLoading"
        >确定</el-button
      >
      <el-button class="iconfont icon-close" size="small" @click="dialogVisible = false"
        >取消</el-button
      >
    </div>
  </div>
</template>

<script>
import { MeasuringPointApi } from '@wiz-api/measuring-point-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const measuringPointApi = new MeasuringPointApi()
const dataCategoryApi = new DataCategoryApi()

export default {
  props: {
    visible: {
      type: Boolean,
    },
    relatedPoints: {
      type: Array,
      default: () => {
        return []
      },
    },
    /* 是否设置勾选添加的最值 */
    isSetMaxSelected: {
      type: Boolean,
      default: false,
    },
    /* 设置可以勾选添加的最大值 */
    maxCount: Number,
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    abpConfigList() {
      return this.$store.getters['Abp/abpConfigList'] || {}
    },
  },
  data() {
    return {
      pageSizeAll: [15, 30, 50, 100],
      saveLoading: false,
      tableLoading: false,
      keyword: '',
      pointList: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      selectedRows: [], // 测点选中项
      label: '',
      pointLabels: [],
    }
  },
  created() {
    // this.getPointLabels()
    this.getPointList()
  },
  methods: {
    // 获取测点标签
    async getPointLabels() {
      const PointLabelsCode = this.abpConfigList[
        'MeasuringPointManagement.DataCategory.PointLabelsCode'
      ] || ['PointLabels']
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: PointLabelsCode, // 风险等级的code
        includeDetails: true, // 默认显示子目录
      })
      if (!err) {
        this.pointLabels = res[0].dataItems
      }
    },
    // 获取测点列表
    async getPointList() {
      this.tableLoading = true
      const [err, res] = await measuringPointApi.findPagedMeasuringPointList({
        body: {
          filter: this.keyword,
          label: this.label,
          maxResultCount: this.page.pageSize,
          skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        },
      })
      this.tableLoading = false
      if (!err) {
        this.pointList = res.items
        this.page.total = res.totalCount
      }
    },
    saveBtnClick() {
      /* 分两种情况，设置了可添加最大值的特殊处理 */
      if (this.isSetMaxSelected) {
        /* 已经添加了16个，继续添加 */
        if (this.relatedPoints.length >= this.maxCount) {
          this.$message.warning('最多只能添加16个测点，请删除不需要的测点再添加！')
          return
        }
      }
      this.$emit('selectedPoint', this.selectedRows)
      this.dialogVisible = false
    },
    sizeChange() {
      this.page.pageNo = 1
      this.getPointList()
    },
    currentChange() {
      this.getPointList()
    },
    selectChange(res) {
      this.selectedRows = res
    },
    /* 判断该测点是否已经被关联，如果已经被关联，则禁止选择 */
    isDisabledToSelect(row) {
      const flag = this.relatedPoints.some((item) => {
        return item.id === row.id
      })
      return !flag
    },
  },
}
</script>

<style lang="scss" scoped>
.points-w {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999;
  width: 60%;
  min-width: 800px;
  background-size: 100% 100%;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  background-image: var(--dialogBgImg);
}

.input_width {
  width: 200px;
}

.bottom_button {
  display: flex;
  justify-content: center;
}

::v-deep .el-radio__label {
  display: none;
}
</style>
